/* eslint-disable prettier/prettier */
import { useMemo } from 'react';
import { allCountries } from 'country-telephone-data';

type CountryCode = {
    code: string;
    name: any;
    isoCode: string;
};

// Memoize the country list outside the hook to avoid unnecessary recalculations
const memoizedCountries: CountryCode[] = allCountries.map((countryObj) => ({
    code: countryObj.dialCode,
    name: countryObj.name,
    isoCode: countryObj.iso2.toUpperCase()
}));

/**
 * Custom hook to get country code by country name.
 * Returns '' if countryName is blank, null, undefined, or not found.
 */
export const useCountryCodeByDesc = (countryName?: string | null): CountryCode | '' => {


    return useMemo(() => {
        if (!countryName || typeof countryName !== 'string' || countryName.trim() === '') {
            return '';
        }

        const normalized: any = countryName.trim().toUpperCase();
        const match: any = memoizedCountries.find(
            (country) => country.isoCode.toUpperCase() === normalized
        );
        if (match) {
            return match.name.replace(/ \([^)]*\)/, '');
        } else {
            return '';
        }
        /*const match: any = memoizedCountries.find(
            (country) => country.name.includes(normalized)
        );*/

        //return match || '';
    }, [countryName]);
};
